var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "from",
    style: {
      backgroundColor: _vm.background
    }
  }, [_c('div', {
    staticClass: "addr_container"
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('span', {
    staticClass: "label"
  }, [_vm._v("From")]) : _vm._e(), _c('AddressLink', {
    attrs: {
      "address": _vm.input.displayAddress
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }